import React from "react";
import { getPrettyDate } from "../lib/format";
import { isSoccer8, isHalfTime, halfOrFullTime, showsForm } from "./matchRowParts";
import { resultLabelClass as pick_result_colour } from "./resultLabel";

const manage_date_format = (kickoff_string) => {
  if (kickoff_string && kickoff_string.includes(" ")) {
    const regexDate = /(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2})/;
    const match = kickoff_string.match(regexDate);
    return getPrettyDate(match[1]) + ", " + match[2];
  } else {
    return `${kickoff_string} `;
  }
};

const h2hLink = (item) => (
  <a style={{ color: "#001489" }} href={"/h2h/" + item.id}>
    View H2H
  </a>
);

// On Soccer 8 HF the half-time row's kickoff cell spans the full-time row too,
// and always links to the head-to-head.
const kickoffCell = (item, pool_title) => {
  if (!isSoccer8(pool_title)) {
    return (
      <td>
        <center>
          <span className="bold">{manage_date_format(item.ko)}</span>
          <br />
          {item.ko === "FIELD" ? null : h2hLink(item)}
        </center>
      </td>
    );
  }
  if (!isHalfTime(item)) return null;
  return (
    <td rowSpan="2">
      <center>
        <span className="bold">{manage_date_format(item.ko)}</span>
        <br />
        {h2hLink(item)}
      </center>
    </td>
  );
};

const MatchSummaryWide = ({ item, pool_title }) => {
  return (
    <tr>
      <td className="bold">
        {"M" + item.mnum}
        {halfOrFullTime(pool_title, item, "H", "F")}
      </td>
      <td>
        <span className="bold">
          {item.teamA}
          {halfOrFullTime(pool_title, item, " (Half Time)", " (Full Time)")}
        </span>
        <br />
        {!showsForm(pool_title) || (isSoccer8(pool_title) && isHalfTime(item)) ? null : (
          <div>
            {item.ko === "FIELD" ? (
              " "
            ) : (
              <>
                <span className={pick_result_colour(item.a1)}> {item.a1} </span>&nbsp;
                <span className={pick_result_colour(item.a2)}> {item.a2} </span>&nbsp;
                <span className={pick_result_colour(item.a3)}> {item.a3} </span>&nbsp;
              </>
            )}
          </div>
        )}
      </td>
      {kickoffCell(item, pool_title)}
      <td className="bold righttext">
        {item.teamB}
        {halfOrFullTime(pool_title, item, " (Half Time)", " (Full Time)")} <br />
        {!showsForm(pool_title) || (isSoccer8(pool_title) && isHalfTime(item)) ? null : (
          <div>
            {item.ko === "FIELD" ? (
              " "
            ) : (
              <>
                <span className={pick_result_colour(item.b1)}> {item.b1} </span>&nbsp;
                <span className={pick_result_colour(item.b2)}> {item.b2} </span>&nbsp;
                <span className={pick_result_colour(item.b3)}> {item.b3} </span>&nbsp;
              </>
            )}
          </div>
        )}
      </td>
    </tr>
  );
};

export default MatchSummaryWide;
